const DISPLAY_FALLBACK = '$19.99';
const CENTS_FALLBACK = 1999;

const envDisplay = process.env.REACT_APP_PREVIEW_PRICE_DISPLAY;
const envCents = process.env.REACT_APP_PREVIEW_PRICE_CENTS;

const parsedCents = envCents ? Number.parseInt(envCents, 10) : NaN;

export const PREVIEW_PRICE_DISPLAY = typeof envDisplay === 'string' && envDisplay.trim().length > 0
  ? envDisplay.trim()
  : DISPLAY_FALLBACK;

export const PREVIEW_PRICE_CENTS = Number.isFinite(parsedCents) && parsedCents > 0
  ? parsedCents
  : CENTS_FALLBACK;

const pricingConfig = {
  PREVIEW_PRICE_DISPLAY,
  PREVIEW_PRICE_CENTS,
};

export default pricingConfig;
